import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

import type { SupporterCommentPetition, SupporterCommentsList } from '../shared/types';

type Result = ModelHookResult<
	{
		supporterComments: SupporterCommentsList;
		petition: SupporterCommentPetition;
	},
	EmptyObject
>;

export function useSupporterComments(): Result {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();

	return useMemo(() => {
		const supporterComments = petition.supporterCommentsConnection.nodes;
		return {
			data: {
				supporterComments,
				petition,
			},
			actions: {},
		};
	}, [petition]);
}
